module.exports = __webpack_public_path__ + "static/img/客户墙00042.1d07272.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/客户墙00042.png
// module id = dRwV
// module chunks = 1